var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9779 12.4147C12.9779 14.8046 11.0421 16.742 8.65422 16.742C6.26637 16.742 4.33038 14.8046 4.33038 12.4147C4.33038 10.0247 6.26623 8.08716 8.65422 8.08716C11.0422 8.08716 12.9779 10.0247 12.9779 12.4147Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.721 12.4146C17.721 14.6642 16.7531 16.4886 15.5591 16.4886C14.3651 16.4886 13.3972 14.6642 13.3972 12.4146C13.3972 10.165 14.365 8.34058 15.559 8.34058C16.753 8.34058 17.7209 10.1644 17.7209 12.4146",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6612 12.4146C19.6612 14.4297 19.3208 16.0642 18.9008 16.0642C18.4808 16.0642 18.1406 14.4301 18.1406 12.4146C18.1406 10.399 18.481 8.76489 18.9008 8.76489C19.3207 8.76489 19.6612 10.3989 19.6612 12.4146Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.cf524b81.svg";
export { ForwardRef as ReactComponent };